import { Box, Chip } from '@mui/material';
import React from 'react';

export type CompanyTypeChipProps = {
    active: boolean;
    main: boolean;
};

const CompanyTypeChip: React.FunctionComponent<CompanyTypeChipProps> = function (props) {
    const { active, main } = props;

    return (
        <Box>
            {active ? (
                <Chip
                    color="primary"
                    label={main ? 'Actif - Principal' : 'Actif'}
                />
            ) : (
                <Chip
                    color="danger"
                    label={main ? 'Fermé - Principal' : 'Fermé'}
                />
            )}
        </Box>
    );
};

export default CompanyTypeChip;
